'use client';

import type { ActiveAuctionsResponse } from '../../services/api';

type Auction = ActiveAuctionsResponse['auctions'][0];

export const getAuctionTargetTime = (auction: Auction): number => {
  const now = Date.now();

  if (auction.status === 'PENDING' && auction.startTime) {
    return new Date(auction.startTime).getTime();
  }

  if (auction.endTime) {
    return new Date(auction.endTime).getTime();
  }

  return now;
};

export const formatAuctionTime = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const isAuctionPending = (auction: Auction): boolean => {
  return auction.status === 'PENDING';
};

export const isAuctionActive = (auction: Auction): boolean => {
  return auction.status === 'ACTIVE';
};

export const calculateTimeRemaining = (auction: Auction): number => {
  const now = Date.now();
  const targetTime = getAuctionTargetTime(auction);
  return Math.max(0, targetTime - now);
};
